
import {
  BASE_URL_4,
  instance4,
} from "App/constants";

import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import fileDownload from "js-file-download";
import { getUserName } from "App/utils/cookies";
export const urlCreateREQ = "/wmsAsset/request/add";
export const urlUpdateREQ = "/wmsAsset/request/update";
export const urlGetReqById = "/wmsAsset/request/list_id";

export const urlVerifikasiBarang = "/wmsAsset/request/validasi_barang";
export const urlVerifikasiTransaksi = "/wmsAsset/request/verifikasi";

export const urlGetBarangReqById = "/wmsAsset/request/list_id";

export const STATUS_OPEN_DRAFT = false;
export const STATUS_PROCESS = true;

// Status Transaksi
export const STATUS_TRANSAKSI_DRAFT = 0;
export const STATUS_TRANSAKSI_PENGAJUAN = 1;
export const STATUS_TRANSAKSI_DISETUJUI = 2;
export const STATUS_TRANSAKSI_PENAWARAN = 3;
export const STATUS_TRANSAKSI_TRIAL = 4;
export const STATUS_TRANSAKSI_PENGAJUAN_PO = 5;
export const STATUS_TRANSAKSI_PENGADAAN = 6;
export const STATUS_TRANSAKSI_SELESAI = 7;
export const STATUS_TRANSAKSI_REVISI = 101;
export const STATUS_TRANSAKSI_REJECT = 99;

// Status Validasi Perbarang
export const STATUS_BARANG_PENGAJUAN = null;
export const STATUS_BARANG_OK = 1;
export const STATUS_BARANG_TOLAK = 2;

export const status_kebutuhan = [
  {
    value: "",
    label: "Pilih Status",
  },
  {
    value: "1",
    label: "Normal",
  },
  {
    value: "2",
    label: "Medium",
  },
  {
    value: "3",
    label: "Urgent",
  },
];

export const STYLE_MASTER_FA = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
});

export const FORM_RESET_STATE_WMS_REQ = {
  idreq: "",
  nama: "",

  unit_id: null,
  unit: "Pilih Unit",

  status_kebutuhan: null,
  status_kebutuhan_nama: "Pilih Tingkat Kebutuhan",
  remark: "",
  remark_verifikasi:"",
  remark_verifikasi2:"",

  user_request: getUserName(),
  status_verifikasi: 0,

  type: "create",
  status: true,

  isOpenDraf: false,
  isProcess: false,
  date: moment(new Date()).local().toDate(),

  historyBarangID:"",
  historyBarangName:"",
  listreq: [],
};

export const FORM_RESET_BARANG = {
    id: null,
    name_barang: "",
    name_barang2: "",
    namasatuan: "Pilih Satuan",
    namagolongan: "Pilih Golongan",
    satuan_id: "",
    golongan_id: null,
    qty: 1,
    remark: "",
    status_cek_barang: null,
    keterangan_cek_barang : null,
    user_cek_barang : null,
    dateCek : null,
    onCreate: true,
    kategori:0,
}

export const FORM_RESET_VERIFIKASI = {
  id: null,
  name_barang: "",
  keterangan_cek_barang: "",
  qty: "",
  namasatuan: "",
}

export const downloadPDF = async (id, fileName) => {
  try {
    const api = await instance4.get(`${BASE_URL_4}/wmsAsset/request/download_tor/${id}`, {
      responseType: "blob",
    });
      fileDownload(api.data, fileName);
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getReqById = async (id) => {
  try {
    const api = await instance4.get(`${urlGetReqById}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data:
          res.data.length > 0
            ? res.data[0]
            : {
                totalTax: 0,
                jumlah: 0,
              },
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getReqListById = async (id) => {
  try {

    const api = await instance4.get(`${urlGetBarangReqById}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        validasi:res.approval_user,
        aksesFile: res.approval_file,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    align: "left",
  },
  {
    id: "name_barang",
    disablePadding: false,
    label: "NAMA BARANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nama_satuan",
    disablePadding: false,
    label: "SATUAN",
    align: "left",
  },
  {
    id: "qty",
    disablePadding: false,
    label: "QTY",
    align: "left",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "status_cek_barang",
    disablePadding: false,
    label: "STATUS",
    align: "center",
    minWidth: "80px",
  },
  {
    id: "keterangan_cek_barang",
    disablePadding: false,
    label: "KETERANGAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "kategori",
    disablePadding: false,
    label: "KATEGORI BARANG",
    align: "left",
    minWidth: "80px",
  },
  {
    id: "user_cek_barang",
    disablePadding: false,
    label: "PEMERIKSA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "dateCek",
    disablePadding: false,
    label: "TGL CEK",
    align: "left",
    minWidth: "100px",
  },
];

export const setPerhitungan = (formData, setFormData, row) => {
  return setFormData({
    ...formData,
    jumlah: row?.jumlah,
    tax: row?.tax,
    total_jumlah: row?.total_jumlah,
  });
};







